<template>
  <b-card v-if="value">
    <b-card-title class="text-justify">
      <a :href="siteUrl + value.contentObject.id" target="_blank">
        {{ value.title }}
      </a>
    </b-card-title>
    <b-card-sub-title class="d-flex">
      <div>{{ value.city }}</div>
      <div class="ml-auto benefit-badge">
        <b-badge
          v-if="benefit"
          variant="warning"
          v-b-tooltip.hover
          :title="benefit"
        >
          Доп. баллы
        </b-badge>
      </div>
    </b-card-sub-title>
    <div class="mt-2">
      <SelectedUniversity
        :filter="filter"
        :partner="value"
      />
    </div>
  </b-card>
</template>

<script>
import _ from 'lodash'
import SelectedUniversity from '@/components/common/university/SelectedUniversity.vue'

export default {
  name: 'UniversityCard',
  components: {
    SelectedUniversity
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    filter: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      defaultImage: '/images/w1400_1.jpg',
      siteUrl: '/gazprom-universities/'
    }
  },
  computed: {
    benefit() {
      let benefit = ''
      if (this.value && this.value.directions) {
        const olympiads = _.uniqBy([].concat(...this.value.directions
          .map((d) => d.recomOlympiads)), 'id')
        if (olympiads.length) {
          benefit = olympiads[0].title
          if (olympiads.length > 1) {
            benefit += ' и др.'
          }
        }
      }
      return benefit
    }
  }
}
</script>

<style scoped>
.benefit-badge {
  font-size: 16px;
}
</style>
